export default "__VITE_PUBLIC_ASSET__a9e81ab9__"